
import React from "react";
import "../App.css";



import abril from "../img/Minuta Abril 2026.jpg";
import mayo  from "../img/Minuta Mayo 2026.jpg";
import junio from "../img/Minuta Junio 2026.jpg";
import julio from "../img/Minuta Julio 2026.png";

const Listajunaeb = () => {

  const minutas = [

     {
      title: "Minuta Abril 2026",
      image: abril,
      pdf: "/pdfs/Minuta Abril 2026.pdf",
    },

    {
      title: "Minuta Mayo 2026",
      image: mayo,
      pdf: "/pdfs/Minuta Mayo 2026.pdf",
    },

    
    {
      title: "Minuta Junio 2026",
      image: junio,
      pdf: "/pdfs/Minuta Junio 2026.pdf",
    },


    {
      title: "Minuta Julio 2026",
      image: julio,
      pdf: "/pdfs/Minuta Julio 2026.pdf",
    },

    
    


  ];

  return (

    <section id="Listajunaeb" className="junaeb-container">

      <h2 className="junaeb-title">
        Alimentación JUNAEB
      </h2>

      <div className="pdf-list-container">

        {minutas.map((minuta, index) => (

          <a
            key={index}
            href={minuta.pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="pdf-card"
            title={minuta.title}
          >

            <div className="image-wrapper">

              <img
                src={minuta.image}
                alt={minuta.title}
                className="minuta-image"
              />

            </div>

          </a>

        ))}

      </div>

    </section>

  );
};

export default Listajunaeb;